<template>
  <div class="ca-tooltip-wrapper">
    <slot />
    <div v-if="!disabled" class="ca-tooltip" :class="`ca-tooltip--${position}`">
      <span class="ca-tooltip__text">{{ text }}</span>
      <span class="ca-tooltip__arrow" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  text: { type: String, required: true },
  position: { type: String, default: "bottom" }, // 'top' | 'bottom' | 'left' | 'right'
  disabled: { type: Boolean, default: false },
});
</script>

<style scoped lang="scss">
.ca-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .ca-tooltip {
    position: absolute;
    background: var(--ca-color-text-body);
    white-space: nowrap;
    padding: 8px 16px;
    border-radius: 8px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 200;

    // vertical
    &--bottom {
      top: calc(100% + 10px);
      left: 50%;
      transform: translateX(-50%);
    }

    &--top {
      bottom: calc(100% + 10px);
      left: 50%;
      transform: translateX(-50%);
    }

    // horizontal
    &--right {
      left: calc(100% + 10px);
      top: 50%;
      transform: translateY(-50%);
    }

    &--left {
      right: calc(100% + 10px);
      top: 50%;
      transform: translateY(-50%);
    }

    &__text {
      color: #fff;
      font-size: var(--font-size-xs);
      font-weight: var(--font-weight-medium);
      line-height: var(--line-height-xs);
      letter-spacing: var(--letter-spacing-xs);
    }
  }

  .ca-tooltip__arrow {
    position: absolute;
    width: 0;
    height: 0;
  }

  // bottom arrow
  .ca-tooltip--bottom .ca-tooltip__arrow {
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid var(--ca-color-text-body);
  }

  // top arrow
  .ca-tooltip--top .ca-tooltip__arrow {
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid var(--ca-color-text-body);
  }

  // right arrow
  .ca-tooltip--right .ca-tooltip__arrow {
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid var(--ca-color-text-body);
  }

  // left arrow
  .ca-tooltip--left .ca-tooltip__arrow {
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid var(--ca-color-text-body);
  }

  &:hover .ca-tooltip {
    opacity: 1;
  }
}
</style>
